<ngx-spinner></ngx-spinner>
<section class="container-table">
  <div class='row'>
    <div class="col-6">
      <h1 class="mb-0">{{ contentTypeData.edit_title }}</h1>
    </div>
    <div class="col-6">
      <div class="text-end">
        <button class="btn_primary mb-3" [routerLink]="[contentTypeData.backLink]" *ngIf="contentTypeData.hasBackLink">
          Back
        </button>
      </div>
    </div>
  </div>


</section>
<section class="container-table my-3">
  <form [formGroup]="mainForm">
    <div class="section-details">
      <div class="form-group">
        <!-- <div class="row"> -->

        <div class="row pe-5" *ngIf="lang=='en'">
          <!-- Render English Fields -->
          <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.english; let i = index"
           [ngClass]="{'d-none': field.type=='password' || field.type=='confirm'}">
            <div *ngIf="field.type != 'hidden'">
                 <label class="form-control-label"
                [ngClass]="{ required: field.required }" [attr.for]="field.label"> {{ field.label }}: </label>
              <div [ngSwitch]="field.type">

                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'"  >
                     <input matInput
                    placeholder="" formControlName="{{field.name}}" [readonly]="true"/> </mat-form-field>


                <div class="img-field" *ngSwitchCase="'file'">

                  <div class="table_image"   >
                    <img [src]='renderImage(field.name,section_index)' *ngIf="!imageSrc && !vaildationImageSize"
                      class="img_fit" /> <img [src]="imageSrc[field.name]" class="img_fit"
                      *ngIf="imageSrc[field.name]!='null' " />
                    <img src="assets/images/no-image-placeholder.png" *ngIf="imageSrc[field.name]=='null'"
                      class="img-fluid" />

                  </div>
                </div>
           </div>
            </div>
          </div>
        </div> <!-- End of Render English Fields -->

        <!-- </div> -->
      </div>
    </div>


  </form>
</section>
